import React, { createRef } from 'react';
import { scrollIntoView } from 'seamless-scroll-polyfill';
import ManualAddressForm from './manual_address_form';

class NewAddress extends React.Component {
  constructor(props) {
    super(props);
    this.addressRef = createRef();
    this.deliveryScrollRef = createRef();
    this.state = {
      search_postcode: '',
      postcode_valid: false,
      search_postcode_error: false,
      addresses: [],
      newAddress: {
        name: '',
        line_1: '',
        line_2: '',
        line_3: '',
        line_4: '',
        line_5: '',
        postcode: '',
      },
      newAddressValid: false,
      nameEmpty: false,
      loading: false,
      showManualAddressForm: false,
      showManualAddressButton: false,
      postcodeErrorMessage: 'No Addresses found for postcode',
      postcodeExcluded: false,
    };

    this.validateNewAddressInput = this.validateNewAddressInput.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.globalHandleInputChange = this.globalHandleInputChange.bind(this);

    this.handleSearchPostCodeChange =
      this.handleSearchPostCodeChange.bind(this);
    this.searchForAddressByPostcode =
      this.searchForAddressByPostcode.bind(this);
    this.clearDownNewAddressPanel = this.clearDownNewAddressPanel.bind(this);
    this.createAddress = this.createAddress.bind(this);
    this.fillAddressForm = this.fillAddressForm.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showManualAddressForm != this.props.showManualAddressForm) {
      this.setState({ showManualAddressForm: nextProps.showManualAddressForm });
    }
  }
  validateNewAddressInput() {
    if (
      !this.state.nameEmpty &&
      this.state.newAddress.line_1 !== '' &&
      this.state.newAddress.line_3 !== '' &&
      this.valid_postcode(this.state.newAddress.postcode).isValid === true
    ) {
      this.setState({
        newAddressValid: true,
        selected: this.state.newAddress,
      });
      this.scrollElementIntoView(this.deliveryScrollRef);
    } else {
      this.setState({ newAddressValid: false, selected: null });
    }
  }
  handleNameChange(e) {
    var newAddress = this.state.newAddress;
    newAddress.name = e.target.value;
    this.setState(
      {
        nameEmpty: newAddress.name !== '' ? false : true,
        newAddress: newAddress,
      },
      () => this.validateNewAddressInput(),
    );
  }

  globalHandleInputChange(e) {
    let newAddress = this.state.newAddress;
    const value = e.target.value;
    const name = e.target.name;

    newAddress[name] = value;
    this.setState(
      {
        newAddress: newAddress,
      },
      () => this.validateNewAddressInput(),
    );
  }

  valid_postcode(postcode) {
    try {
      postcode = postcode.replace(/\s/g, '');
      const format = postcode
        .toUpperCase()
        .match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);
      const finalValue = `${format[1]} ${format[2]}`;
      const regex =
        /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})$/i;

      return {
        isValid: regex.test(postcode),
        formatedPostCode: finalValue,
        error: false,
        info: 'It is a valid postcode',
      };
    } catch (error) {
      return { error: true, info: 'Invalid post code has been entered!' };
    }
  }

  handleSearchPostCodeChange(e) {
    this.setState({
      search_postcode: e.target.value,
      search_postcode_error: false,
    });
    this.valid_postcode(e.target.value).isValid === true
      ? this.setState({ postcode_valid: true })
      : this.setState({ postcode_valid: false });
    if (e.target.value === '') {
      this.setState({ addresses: [] });
    }
  }

  scrollElementIntoView(element) {
    scrollIntoView(element.current, {
      behavior: 'smooth',
    });
  }

  searchForAddressByPostcode() {
    if (this.state.newAddress.name === '') {
      this.setState({ nameEmpty: true });
      return;
    }

    this.setState({
      search_postcode_error: false,
      addresses: [],
      loading: true,
      showManualAddressForm: false,
    });

    if (this.state.postcode_valid) {
      $.ajax({
        url: this.props.addressEnquiryUrl,
        method: 'GET',
        dataType: 'json',
        data: {
          postcode: this.state.search_postcode,
        },
        success: data => {
          this.setState({
            addresses: data,
            loading: false,
            showManualAddressButton: true,
            showManualAddressForm: false,
            postcodeExcluded: false,
          });
          this.props.handleSignedInpostcodeError(false);
          this.scrollElementIntoView(this.addressRef);
        },
        error: ({ responseText }) => {
          const postcodeErrorMessage = JSON.parse(responseText).message;
          const postcodeExcluded = JSON.parse(responseText).postcode_excluded;

          const showManualAddressForm = !postcodeExcluded ? true : false;

          this.setState({
            search_postcode_error: true,
            loading: false,
            showManualAddressForm,
            postcodeErrorMessage,
            postcodeExcluded,
          });
          this.props.handleSignedInpostcodeError(true);
          this.scrollElementIntoView(this.addressRef);
        },
      });
    }
  }

  clearDownNewAddressPanel() {
    this.setState({
      search_postcode: '',
      postcode_valid: false,
      search_postcode_error: false,
      addresses: [],
      newAddress: {
        name: '',
        line_1: '',
        line_2: '',
        line_3: '',
        line_4: '',
        line_5: '',
        postcode: '',
      },
      newAddressValid: false,
    });
  }

  createAddress() {
    const {
      configGenericError,
      current_step: currentStep,
      deliveryAddressUrl,
      getAddressBook,
      handleGuestBillingAddress,
      handleTelephoneError,
      method,
      progressToCardDetails,
      setAddressFromAddressBook,
      setAddressMode,
      signed_in: signedIn,
      telephone,
      toggleGenericError,
    } = this.props;
    const { newAddress } = this.state;

    let data = {};
    if (currentStep === 'PAYMENT') {
      data = {
        billing_name: newAddress.name,
        billing_address_1: newAddress.line_1,
        billing_address_2: newAddress.line_2,
        billing_address_3: newAddress.line_3,
        billing_address_4: newAddress.line_4,
        billing_address_5: newAddress.line_5,
        billing_postcode: newAddress.postcode,
      };
    } else {
      data = {
        new_address: {
          name: newAddress.name,
          line_1: newAddress.line_1,
          line_2: newAddress.line_2,
          line_3: newAddress.line_3,
          line_4: newAddress.line_4,
          line_5: newAddress.line_5,
          postcode: newAddress.postcode,
        },
      };
    }

    if (handleGuestBillingAddress) {
      handleGuestBillingAddress(newAddress);
    } else {
      if (signedIn !== true && telephone == '') {
        handleTelephoneError(true);
      } else {
        this.setState({
          disableContinueButton: true,
        });

        $.ajax({
          url: deliveryAddressUrl,
          method: method ? method : 'POST',
          dataType: 'json',
          data: data,
          success: () => {
            this.setState({
              showManualAddressForm: false,
              disableContinueButton: false,
            });

            if (signedIn === true) {
              getAddressBook();
              setAddressFromAddressBook(this.state.newAddress);
              setAddressMode('ADDRESS_BOOK');
              this.clearDownNewAddressPanel();
              if (currentStep === 'PAYMENT') {
                progressToCardDetails();
              }
            } else {
              setAddressFromAddressBook(this.state.newAddress);
              setAddressMode('ADDRESS_BOOK');
              this.clearDownNewAddressPanel();
              if (currentStep === 'PAYMENT') {
                progressToCardDetails();
              }
            }
          },
          error: e => {
            this.setState({ disableContinueButton: false });
            configGenericError({
              title: 'Error creating address',
              body: (
                <div>
                  <p>
                    Unfortunately there was an error creating your new address.
                  </p>
                  <p>
                    We are sorry for any inconvenience this may cause. Please
                    try again later. If the problem persists, please contact our
                    customer service team.
                  </p>
                </div>
              ),
              errorButton: true,
              errorButtonTitle: 'Close',
              errorButtonAction: toggleGenericError,
              closeAction: toggleGenericError,
            });
          },
        });
      }
    }
  }

  fillAddressForm(index) {
    this.setState({ showManualAddressForm: true }, () => {
      var selectedAddress = this.state.addresses[index];
      this.setState(
        {
          newAddress: {
            name: this.state.newAddress.name,
            line_1: selectedAddress.line_1,
            line_2: selectedAddress.line_2,
            line_3: selectedAddress.line_3,
            line_4: selectedAddress.line_4,
            line_5: selectedAddress.line_5,
            postcode: selectedAddress.postcode,
          },
        },
        () => this.validateNewAddressInput(),
      );
    });
  }

  render() {
    const { postcodeExcluded, postcodeErrorMessage } = this.state;

    var loading = this.state.loading === true && (
      <span className="loading">
        <i className="icon-spinner icon-spin icon-large" />
      </span>
    );

    const postcodeSearchError = this.state.search_postcode_error === true && (
      <p>
        <span className="search-postcode--error">{postcodeErrorMessage}</span>
      </p>
    );

    var nameEmptyError = this.state.nameEmpty && (
      <p>
        <span className="search-postcode--error">
          Please enter a name for the address.
        </span>
      </p>
    );

    var addresses = '';
    if (this.state.addresses.length > 0) {
      addresses = (
        <div className="available--addresses">
          <ul>
            {this.state.addresses.map((address, index) => {
              return (
                <li key={index} onClick={() => this.fillAddressForm(index)}>
                  {address.short_name}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }

    return (
      <div
        className={
          'checkout-sub-panel find-address ' +
          (this.props.addressMode !== 'NEW_ADDRESS' ? 'hide' : '')
        }>
        <div className="new-address">
          <h2>Enter a new Address</h2>
          {!this.props.guestPostcodeError && (
            <div>
              <div className="input-address">
                <div className="manual-address-wrapper">
                  <div className="fl-fb-50">
                    <label htmlFor="input-name">
                      Name <strong className="required">*</strong>
                    </label>
                    <input
                      onChange={this.handleNameChange}
                      type="text"
                      value={this.state.newAddress.name}
                      autoComplete="off"
                      name="input-name"
                      id="input-name"
                    />
                    {nameEmptyError}

                    <label ref={this.addressRef} htmlFor="postcode-search">
                      Please enter your postcode{' '}
                      <strong className="required">*</strong>
                    </label>
                    <div className="fl fw-w ai-c">
                      <input
                        type="text"
                        value={this.state.search_postcode}
                        onChange={this.handleSearchPostCodeChange}
                        onBlur={this.checkName}
                        autoComplete="off"
                        name="postcode-search"
                        id="postcode-search"
                        className="new-address-postcode-search"
                      />
                      <button
                        className="find-address-button fl-1"
                        onClick={this.searchForAddressByPostcode}
                        disabled={!this.state.postcode_valid}
                        data-testid={
                          this.props.signed_in === false
                            ? 'guest-find-address'
                            : 'account-find-address'
                        }>
                        {this.state.loading ? loading : 'Find Address'}
                      </button>
                      {this.state.showManualAddressButton && !postcodeExcluded && (
                        <div className="manual-select-wrapper">
                          <button
                            className="manual-select"
                            onClick={() =>
                              this.setState({
                                showManualAddressForm: true,
                              })
                            }>
                            Enter Address Manually
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {postcodeSearchError}
              </div>
              {addresses}
            </div>
          )}
        </div>
        {(this.props.showManualAddressForm && !postcodeExcluded) ||
        (this.state.showManualAddressForm && !postcodeExcluded) ? (
          <div>
            <ManualAddressForm
              handleAddressLine1Change={this.globalHandleInputChange}
              handleAddressLine2Change={this.globalHandleInputChange}
              handleAddressLine3Change={this.globalHandleInputChange}
              handleAddressLine4Change={this.globalHandleInputChange}
              handlePostCodeChange={this.globalHandleInputChange}
              line1={this.state.newAddress.line_1}
              line2={this.state.newAddress.line_2}
              line3={this.state.newAddress.line_3}
              line4={this.state.newAddress.line_4}
              postcode={this.state.newAddress.postcode}
            />

            <button
              ref={this.deliveryScrollRef}
              disabled={
                !this.state.newAddressValid || this.state.disableContinueButton
              }
              className={`next-panel test ${
                this.state.disableContinueButton ? 'disabled' : ''
              }`}
              onClick={
                this.props.setGuestErrorAddress
                  ? this.props.setGuestErrorAddress
                  : this.createAddress
              }>
              {this.state.disableContinueButton ? (
                <div className="loader"></div>
              ) : this.props.current_step !== 'PAYMENT' ? (
                'Continue to Delivery Details'
              ) : (
                'Set Address'
              )}
            </button>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default NewAddress;
